import {Component, EventEmitter, Input, Optional, Output, ViewEncapsulation} from '@angular/core';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'si-list-dynamic',
  templateUrl: './list-dynamic.component.html',
  styleUrls: ['./list-dynamic.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ListDynamicComponent {
  @Input() addButton = true;
  @Input() addButtonText = 'CORE_ADD';
  @Input() addButtonDisabled: boolean;
  @Input() componentTitle: string;
  @Input() componentTitleClass = 'bold';
  @Input() itemAuxId = 0;
  @Input() iconClass: string;
  @Input() readMode = false;
  @Output() itemAuxIdChange = new EventEmitter<number>();
  @Output() itemsChange = new EventEmitter<any[]>();
  private _items: any[];

  constructor(
    @Optional() private form: NgForm
  ) {
  }

  get items() {
    return this._items;
  }

  @Input()
  set items(val) {
    if (!val) {
      val = [];
    }

    if (val.length) {
      val.map(item => item.auxId = this.itemAuxId++);
      this.itemAuxIdChange.emit(this.itemAuxId);
    }

    this._items = val;
  }

  onClickAddRow(): void {
    if (!this.items) {
      this.items = [];
    }

    this.items.unshift({
      auxId: this.itemAuxId++
    });
    this.itemAuxIdChange.emit(this.itemAuxId);

    this.itemsChange.emit(this.items);
  }

  onClickDeleteRow(index: number): void {
    this.items.splice(index, 1);
    this.itemsChange.emit(this.items);
    if (this.form) {
      this.form.control.markAsDirty();
    }
  }
}
